import React from "react";

import Form from "antd/es/form";
import { defineMessages, useIntl } from "react-intl";

import RadioGroup from "@app/component/input/RadioGroup";
import CardConfigurationProps from "@app/scene/dashboard/types/CardConfigurationProps";
import { MileageTrackingAggregationType } from "@app/types/dashboard/cards/mileageTracking/MileageTrackingCardConfiguration";

const messages = defineMessages({
  aggregationType: {
    id: "dashboard.editModal.criteria.mileageTracking.aggregationType",
    defaultMessage: "Aggregation type",
    description:
      "Title of the Aggregation type field in a criteria form in Edit Mileage Tracking Modal on Dashboard",
  },
});

const CriteriaFormComponent: React.FC<CardConfigurationProps> = () => {
  const intl = useIntl();

  return (
    <div>
      <Form.Item
        label={intl.formatMessage(messages.aggregationType)}
        name={["criteria", "aggregationType"]}
      >
        <RadioGroup
          defaultValue={MileageTrackingAggregationType.SUM}
          options={[MileageTrackingAggregationType.SUM, MileageTrackingAggregationType.AVG]}
          optionType="button"
        />
      </Form.Item>
    </div>
  );
};

export default CriteriaFormComponent;
